import {
    GET_SYNC_STATUS_REQUEST,
    GET_SYNC_STATUS_SUCCESS,
    GET_SYNC_STATUS_FAILURE,
    GET_SYNC_STATUS,
    START_SYNC_REQUEST,
    START_SYNC_SUCCESS,
    START_SYNC_FAILURE,
    START_SYNC
} from './constants';
import {IActions} from './typedef';

export const getSyncStatusRequest = (): IActions => ({
    type: GET_SYNC_STATUS_REQUEST
});

export const getSyncStatusSuccess = (status: boolean): IActions => ({
    type: GET_SYNC_STATUS_SUCCESS,
    status
});

export const getSyncStatusFailure = (): IActions => ({
    type: GET_SYNC_STATUS_FAILURE
});

export const getSyncStatusAction = () => ({
    type: GET_SYNC_STATUS
});

export const startSyncRequest = (): IActions => ({
    type: START_SYNC_REQUEST
});

export const startSyncSuccess = (status: boolean): IActions => ({
    type: START_SYNC_SUCCESS,
    status
});

export const startSyncFailure = (): IActions => ({
    type: START_SYNC_FAILURE
});

export const startSyncAction = () => ({
    type: START_SYNC
});
